// Small phones held sideways (QA 5 Nov 2026: on an iPhone SE in landscape the cards were 10 px tall
// and the Game Over box was cut off). The apps lock phones upright; on the website and the portals
// a sideways phone gets this note over the game instead. Tablets and laptops are never affected:
// it needs a touch screen, landscape, and less than 500 px of height (an iPhone Pro Max on its side is 430).
import React from "react";
import styled from "styled-components";
import { t } from "../i18n";

const Cover = styled.div`
  display: none;
  @media (orientation: landscape) and (max-height: 499px) and (pointer: coarse) {
    display: flex;
  }
  position: fixed;
  inset: 0;
  z-index: 10000;
  background: #2c2f3e;
  color: #e2e3ea;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 24px;
  gap: 10px;
  font-family: inherit;
`;

const Phone = styled.div`
  width: 34px;
  height: 56px;
  border: 3px solid #fecf6f;
  border-radius: 8px;
  transform: rotate(-90deg);
  animation: rafiki-turn 1.6s ease-in-out infinite alternate;
  @keyframes rafiki-turn {
    to {
      transform: rotate(0deg);
    }
  }
  @media (prefers-reduced-motion: reduce) {
    animation: none;
    transform: none;
  }
`;

const RotateNotice: React.FC = () => (
  <Cover data-rotate-notice role="alert" aria-live="polite">
    <Phone aria-hidden="true" />
    <strong style={{ fontSize: "1.1rem", color: "#fecf6f" }}>{t("rotate.title")}</strong>
    <span style={{ fontSize: "0.9rem" }}>{t("rotate.body")}</span>
  </Cover>
);

export default RotateNotice;
